const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/persons/$id.settlements.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindPersonDetailsQueryOptions, getFindPersonSettlementsQueryOptions, mapPersonType } from '@api';
import { isPersonSettlementsTabEligible } from '@common';
import { hasPermission } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/persons/$id/settlements')({
  beforeLoad: async ({
    context: {
      permissions,
      queryClient
    },
    params: {
      id
    }
  }) => {
    if (!hasPermission(permissions, {
      permission: 'FINANCE',
      action: 'READ'
    })) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true
      });
    }
    const personDetailsResponse = await queryClient.ensureQueryData(getFindPersonDetailsQueryOptions(id));
    const personDetails = mapPersonType(personDetailsResponse.data);
    if (!isPersonSettlementsTabEligible({
      companyLinks: personDetails.companies,
      hasFinanceRead: true
    })) {
      throw redirect({
        to: '/persons/$id/general',
        params: {
          id
        },
        replace: true,
        throw: true
      });
    }
  },
  loader: async ({
    context: {
      queryClient
    },
    params: {
      id
    }
  }) => {
    queryClient.ensureQueryData(getFindPersonSettlementsQueryOptions(id));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});